import { render, staticRenderFns } from "./exportationTable.vue?vue&type=template&id=4f28f512"
import script from "./exportationTable.vue?vue&type=script&lang=js"
export * from "./exportationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports